import React, { PureComponent } from 'react'
import dataProvider, { GET_LIST } from "providers/dataProvider";
import SuggestionsPatientsListComponent
  from 'components/pages/requisitions/SuggestionsPatientsListComponent';
import WidgetType1 from 'components/ui_components/Widgets/WidgetType1/WidgetType1';
import styles from './WidgetPatient.module.scss'
import BaseForm from 'components/ui_components/BaseForm/BaseForm.js';

class WidgetPatientContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.timer = null

    this.state = {
      dataLoading: false,
      patientsData: []
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.submitData) === JSON.stringify(this.props.submitData)) return;

    const filterData = {};

    const patientKeyFields = [
      'patientFirstName', 'patientLastName', 'patientMiddleName',
      'patientDobMonth', 'patientDobDate', 'patientDobYear',
      'patientGenderCode'
    ];

    this.props.inputsById.forEach(id => {
      if (!patientKeyFields.includes(id)) {
        return;
      }
      
      const val = this.props.submitData[id];
      if (val === '' || val === undefined || val === '[PLACE_HOLDER]' || Number.isNaN(val)) {
        return;
      }
      
      // Ignore default DOB fields for suggestion searches to avoid over-filtering
      if ((id === 'patientDobMonth' && val === '01') || (id === 'patientDobDate' && val === '01') || (id === 'patientDobYear' && val === '1900')) {
        return;
      }
      
      filterData[id] = val;
    });

    if (Object.keys(filterData).length === 0) {
      if (this.state.patientsData.length > 0) {
        this.setState({ patientsData: [] });
      }
      return;
    }

    if (this.timer) {
      clearTimeout(this.timer)
    }

    this.props.handleEditSelectedPatient();

    this.timer = setTimeout(() => {
      this.loadPatients(filterData)
    }, 500)
  }

  loadPatients = async (filterData) => {
    if (this.props.isNewPatient) return;
    this.setState({
      dataLoading: true
    })

    const hasBothNames = filterData.patientFirstName && filterData.patientLastName && 
                        typeof filterData.patientFirstName === 'string' && typeof filterData.patientLastName === 'string' &&
                        filterData.patientFirstName.trim() !== '' && filterData.patientLastName.trim() !== '';

    if (hasBothNames) {
      // Make two API calls: one with names as entered, one with names swapped
      const filterDataSwapped = { ...filterData };
      const tempFirst = filterDataSwapped.patientFirstName;
      filterDataSwapped.patientFirstName = filterDataSwapped.patientLastName;
      filterDataSwapped.patientLastName = tempFirst;

      try {
        // We use sequential awaits instead of Promise.all to avoid potential 
        // request cancellation issues in the data provider when multiple 
        // requests for the same resource are fired simultaneously.
        const response1 = await dataProvider(GET_LIST, 'patients', {
          filter: filterData,
          pagination: { perPage: -1 }
        });

        const response2 = await dataProvider(GET_LIST, 'patients', {
          filter: filterDataSwapped,
          pagination: { perPage: -1 }
        });

        const data1 = response1.data || [];
        const data2 = response2.data || [];
        
        // Combine results and remove duplicates based on patient ID
        const combinedData = [...data1];
        const existingIds = new Set(data1.map(p => p.id));
        
        data2.forEach(patient => {
          if (!existingIds.has(patient.id)) {
            combinedData.push(patient);
            existingIds.add(patient.id);
          }
        });

        this.setState({
          dataLoading: false,
          patientsData: combinedData
        });
      } catch (error) {
        console.error('Error loading patients:', error);
        this.setState({
          dataLoading: false,
          patientsData: []
        });
      }
    } else {
      // Normal single API call
      dataProvider(GET_LIST, 'patients', {
        filter: filterData,
        pagination: {
          perPage: -1,
        }
      })
      .then(({ data, total }) => {
        this.setState({
          dataLoading: false,
          patientsData: data
        })
      })
      .catch(error => {
        console.error('Error loading patients:', error);
        this.setState({
          dataLoading: false,
          patientsData: []
        });
      });
    }
  }

  handleInputs = (e) => {
    this.props.handleInputs(e);
  }

  render() {
    const { inputsByHash, title, inputsGroupsByHash, inputsGroupsById, baseFormStyles } = this.props;

    const content = <div className={styles.patientContent}>
      <div className={styles.patientListInputsCol}>

        <BaseForm
          {...baseFormStyles}
          inputsByHash={inputsByHash}
          inputsGroupsByHash={inputsGroupsByHash}
          inputsGroupsById={inputsGroupsById}
          handleInputs={this.handleInputs}
          groupTitleStyles={'font-weight: 700; font-size: 14px; margin: 10px 0 0;'}
        />
      </div>

      <div className={styles.suggestedPatientListCol}>
        <SuggestionsPatientsListComponent
          dataLoading={this.state.dataLoading}
          handleNewPatientCheck={this.props.handleNewPatientCheck}
          handleClickSuggestedPatient={this.props.handleClickSuggestedPatient}
          patientsData={this.state.patientsData}
          isNewPatient={this.props.isNewPatient}
        />
      </div>

    </div>

    if (this.props.hideWidgetWrapper) {
      return content;
    }

    return (
      <WidgetType1
        title={title}
        content={content}
        styles={`width: 100%;`}
      />
    )
  }
}


export default WidgetPatientContainer

WidgetPatientContainer.defaultProps = {
  inputsById: [],
};